import axios from "../plugins/parseAxios";
export class MeterAPI {
  constructor(props) {}
  static getMeterByArea(payload) {
    return axios.post("functions/getMeterByArea", {
      areaId: payload.areaId
    });
  }
  static getMeterByAreas(payload) {
    return axios.post("functions/getMeterByAreas", {
      areaIds: payload.areaIds
    });
  }
  static getMeterByMarket(marketId, type) {
    return axios.post("functions/getMeterByMarket", {
      marketId,
      type
    });
  }
  static createMeter(payload) {
    return axios.post("functions/createMeter", payload);
  }
  static updateMeter(payload) {
    return axios.post("functions/updateMeter", payload);
  }
  static removeMeter(payload) {
    return axios.post("functions/removeMeter", { id: payload.id });
  }
  static getMeterDigitalByMarkets(marketIds) {
    return axios.post("functions/getMeterDigitalByMarkets", {
      marketIds
    });
  }
  static getMeterByIds(meterIds) {
    return axios.post("functions/getMeterByIds", {
      meterIds
    });
  }
  static getMeter(id) {
    return axios.post("functions/getMeter", {id});
  }
  static getMeterByProject(payload) {
    return axios.post("functions/getMeterByProject", payload);
  }
}
